import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Table, Card, CardBody } from "reactstrap"
import CardItem from "./CardItem" 
import ModalForm from "./ModalForm"
import Paginator from "components/Common/Paginator/Paginator"
import InventoryService from "services/SalesDeveloper/InventoryService"
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from "store/adminFilter/actions"

const ManageInventory = () => {
  const inventoryService = new InventoryService()
  const [modal, setModal] = useState(false)
  const [editObj, setEditObj] = useState(null)
  const [add, setAdd] = useState(true)
  const [searchWord, setSearchWord] = useState("")
  const [list, setList] = useState([])
  const [active, setActive] = useState("all")
  const AuthData = useSelector(state => state.Auth)
  const isExist = (data) => AuthData.permissions[data]
  const [filtersParams, setFilterParams] = useState(null)
  const [shouldGetData, setShouldGetData] = useState(false)
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  })
  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(appendFilters({compound_id: null}))
  },[])

  const addHandler = () => {
    setAdd(true)
    setEditObj(null)
    toggle()
  }
  const toggle = () => {
    setModal(!modal)
  }

  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)

  }
  useEffect(() => {

    const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (searchWord.trim().length) params['keyword'] = searchWord
      setFilterParams({ ...params })
    }, 1000)

    return () => clearTimeout(timeoutId)
  }, [active, searchWord])

   
  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Manage Inventory</title>
        </MetaTags>
        <Container fluid >
          <Row className="mb-1">
            <Col md={6}>
              <h4>Manage Inventory</h4>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text"
                 className="form-control"
                  placeholder="Search by Name of Sheet, I.D"
                   onChange={(e) => OnSearchChange(e)}
                  value={searchWord} />
              </div>
            </Col>
            <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                {isExist('manage_inventory') && <button className="btn btn-success btnHeight px-4" onClick={addHandler}>Add a Sheet Template</button>}
              </div>
            </Col>
          </Row>
          <Row >
            <Col sm={6} className="my-4">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all")
                }}
              >
                All
             </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("active")
                }}
              >
                Active
              </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("deactive")
                }}
              >
                Deactive
              </button>
            </Col>
          </Row>
          <div>
            <Card className="w-100 ">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-16'>I.D</th>
                            <th className='font-size-16'>Name</th>
                            <th className='font-size-16'>Status</th>
                            <th className='font-size-16'></th>

                          </tr>
                        </thead>
                        <tbody>

                          {list.map((item, index) => {
                            return <CardItem
                              key={index}
                              index={index}
                              {...item}
                              item={item}
                              setAdd={setAdd}
                              setEditObj={setEditObj}
                              toggleModal={toggle}
                              Service={InventoryService}
                              setShouldGetData={setShouldGetData}
                            />
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-end" md={8} sm={12}>
                <Paginator
                  service={inventoryService}
                  pageOptions={pageOptions}
                  setData={(data) =>setList([...data])}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                />
              </Col>
            </Row>
          </div>

        </Container>
      </div>

      {modal && (
        <ModalForm
          modal={modal}
          toggle={toggle}
          isAdd={add}
          editObj={editObj}
          setList={setList}
          setShouldGetData={setShouldGetData}
          Service={InventoryService}
        />
      )}
    </React.Fragment>
  )
}

export default ManageInventory;
